// Repairro service catalog — single source of truth
import { Droplets, Snowflake, Fan, WashingMachine } from "lucide-react";

export const CATEGORIES = [
  {
    id: "ro",
    name: "RO Service",
    short: "RO",
    icon: Droplets,
    color: "#0EA5E9",
    bg: "#E0F2FE",
    tagline: "Pure water, pure peace of mind",
    startingPrice: 299,
    status: "live",
    brands: ["Kent", "Aquaguard", "Pureit", "Livpure", "HUL", "Eureka Forbes", "AO Smith", "Whirlpool"],
    services: [
      { id: "ro-install", name: "RO Installation", price: 499, time: "60-90 min", desc: "End-to-end installation by certified plumber.", includes: ["Site inspection", "Wall mounting", "Inlet connection", "Tap fitting", "TDS test"] },
      { id: "ro-repair", name: "RO Repair", price: 299, time: "45-60 min", desc: "Diagnostic + minor fixes (extra parts billed separately).", includes: ["Issue diagnosis", "Pressure check", "Leak fix", "Performance test"] },
      { id: "ro-amc", name: "RO AMC (Annual)", price: 799, time: "12 months", desc: "3 service visits + priority repair across the year.", includes: ["3 deep services", "Filter replacement (parts at MRP)", "Priority response", "10% off spares"] },
      { id: "ro-cleaning", name: "RO Deep Cleaning", price: 399, time: "45 min", desc: "Sanitize tank + housing for fresh-tasting water.", includes: ["Tank sanitization", "Housing flush", "External cleaning"] },
      { id: "ro-filter", name: "RO Filter/Membrane Replacement", price: 349, time: "30-45 min", desc: "Labour only — filters charged at MRP.", includes: ["Sediment filter", "Carbon filter", "Membrane swap (if needed)", "TDS verification"] },
    ],
  },
  {
    id: "ac",
    name: "AC Service",
    short: "AC",
    icon: Snowflake,
    color: "#0284C7",
    bg: "#DBEAFE",
    tagline: "Coming soon",
    startingPrice: 399,
    status: "soon",
    brands: [],
    services: [],
  },
  {
    id: "fan",
    name: "Fan Service",
    short: "Fan",
    icon: Fan,
    color: "#7C3AED",
    bg: "#EDE9FE",
    tagline: "Coming soon",
    startingPrice: 149,
    status: "soon",
    brands: [],
    services: [],
  },
  {
    id: "washing_machine",
    name: "Washing Machine Service",
    short: "Washing Machine",
    icon: WashingMachine,
    color: "#0891B2",
    bg: "#CFFAFE",
    tagline: "Coming soon",
    startingPrice: 299,
    status: "soon",
    brands: [],
    services: [],
  },
];

export const SEGMENTS = [
  { id: "home", name: "Home", desc: "Family appliance installation, repair & maintenance with same-day visits.", cta: "Book for Home" },
  { id: "shop", name: "Shop / Office", desc: "Commercial units, bulk service contracts & priority response SLAs.", cta: "Book for Shop/Office" },
  { id: "professional", name: "Working Professional", desc: "Evening & weekend slots, fast online booking, no calls needed.", cta: "Book for Professional" },
];

export const CITIES = [
  { id: "lucknow", name: "Lucknow", status: "live" },
  { id: "varanasi", name: "Varanasi", status: "soon" },
  { id: "kanpur", name: "Kanpur", status: "soon" },
];

export const SLOTS = [
  { id: "morning", label: "Morning", time: "8 AM – 12 PM", highlight: false },
  { id: "afternoon", label: "Afternoon", time: "12 PM – 5 PM", highlight: false },
  { id: "evening", label: "Evening", time: "5 PM – 8 PM", highlight: true },
  { id: "urgent", label: "Urgent — Same Day", time: "Within 4 hrs", highlight: true },
];

export const FAQS = [
  { q: "How quickly can a technician reach my home?", a: "For Lucknow, same-day service is available when booked before 2 PM. Urgent slots are dispatched within 4 hours." },
  { q: "Do you service all brands of RO, AC, Fan and Washing Machine?", a: "Yes. We cover all major brands — Kent, Aquaguard, Daikin, LG, Samsung, Voltas, Havells, IFB, Bosch and more. See the brand list on each service." },
  { q: "How is pricing calculated? Are there hidden charges?", a: "Pricing is transparent. The 'Starting from' price covers labour for the base scope. Replacement parts (if needed) are billed at MRP after your approval." },
  { q: "What does an AMC plan include?", a: "Annual Maintenance Contracts include scheduled deep services (2-3 visits/year), priority repair response, discounts on spares, and a fixed yearly fee — no surprise bills." },
  { q: "Can I reschedule or cancel my booking?", a: "Yes. You can reschedule or cancel up to 2 hours before the slot through WhatsApp or by calling our team — no cancellation fee." },
  { q: "Are your technicians background-verified?", a: "Every Repairro technician is Aadhar-verified, skill-tested and uniformed. You'll see their photo & ID before they arrive." },
  { q: "Do you offer service for shops, offices and apartments?", a: "Absolutely. We have dedicated commercial contracts for offices, retail shops and societies with priority SLAs and bulk pricing." },
  { q: "What payment methods do you accept?", a: "UPI, all major cards, net banking and cash — pay only after the job is done to your satisfaction. No advance required for standard jobs." },
];

export const TESTIMONIALS = [
  { name: "Anjali Verma", location: "Gomti Nagar, Lucknow", service: "RO Service", rating: 5, text: "Booked RO filter replacement at 9 AM — technician was at my door by 11 AM. Clean work, transparent pricing. Will recommend to family." },
  { name: "Rohit Singh", location: "Hazratganj, Lucknow", service: "AC Service", rating: 5, text: "AC was not cooling for a week. Repairro's tech identified a gas leak and fixed it the same day. Cheaper than the brand service centre." },
  { name: "Mrs. Sharma", location: "Mau", service: "Fan Service", rating: 5, text: "Three ceiling fans installed in one visit. Clean, polite technician, and the price was exactly what was quoted online. No surprises." },
  { name: "Amit Patel", location: "Indira Nagar, Lucknow", service: "Washing Machine", rating: 4, text: "Front-load drum descaling done well. Machine sounds smoother and clothes come out cleaner. Booked the AMC right after." },
];

export const TRUST_BADGES = [
  { label: "1000+ Services Done", icon: "check-circle" },
  { label: "Same Day Service", icon: "zap" },
  { label: "Verified Technicians", icon: "shield-check" },
  { label: "No Hidden Charges", icon: "wallet" },
  { label: "4.8/5 Rating", icon: "star" },
];

export const CONTACT = {
  whatsapp: "+919453097609",
  whatsappLink: "https://wa.me/919453097609",
  phone: "+91 9453097609",
  phoneLink: "tel:+919453097609",
  email: "hello@repairro.com",
  emailLink: "mailto:hello@repairro.com",
};

export const getCategoryById = (id) => CATEGORIES.find((c) => c.id === id);
export const getServiceById = (categoryId, serviceId) => {
  const cat = getCategoryById(categoryId);
  return cat ? cat.services.find((s) => s.id === serviceId) : null;
};

export const AMC_PLANS = [
  { name: "Basic", price: 799, popular: false, features: ["1 deep service / year", "Priority response", "Phone support", "5% off spares"] },
  { name: "Standard", price: 1499, popular: true, features: ["3 deep services / year", "Priority dispatch", "WhatsApp support", "15% off spares", "1 free gas top-up (AC)"] },
  { name: "Premium", price: 2499, popular: false, features: ["Unlimited service visits", "Same-day SLA", "Dedicated manager", "20% off spares", "Free filter (RO) once"] },
];
